import { Link, Text } from '@approvalmax/ui/src/components';
import { intl } from '@approvalmax/utils';
import moment from 'moment';
import { useMemo } from 'react';
import { getPath, Path } from 'urlBuilder';

import { SelectableBillItem } from '../../../../NetSuiteBillPaymentRequestForm.types';

export const useTableRowData = (
    companyId: string,
    selectableBills: SelectableBillItem[],
    currencyPrecision: number
) => {
    return useMemo(
        () =>
            selectableBills.map((item) => ({
                id: item.id,
                transactionId: item.transactionId,
                reference: item.reference,
                dateDue: (
                    <Link font='body' href={getPath(Path.request, item.requestId, companyId)} external>
                        <Text font='body' fontSize='small' wrap={false}>
                            {item.dateDue ? moment.utc(item.dateDue).format('ll') : null}
                        </Text>
                    </Link>
                ),
                type: (
                    <Link font='body' fontSize='small' href={getPath(Path.request, item.requestId, companyId)} external>
                        {item.type}
                    </Link>
                ),
                originalAmount: intl.formatNumber(item.originalAmount, currencyPrecision),
                amountDue: intl.formatNumber(item.amountDue, currencyPrecision),
                currency: item.currencyName,
                discountDate: item.discountDate ? moment.utc(item.discountDate).format('ll') : null,
                discountAvailable: intl.formatNumber(item.discountAvailable, currencyPrecision),
            })),
        [companyId, selectableBills, currencyPrecision]
    );
};
